module.exports = new __parcel__URL__("tabs_ko.2f6f9916.webp").toString();